<template>
  <MetaButton data-testid="item-views" tooltip="Analytics" tooltip-placement="top-start" @click.prevent="requestTab('#analytics')">
    <MetadataIcon name="eye" />
    <span>{{ visitsMessage }}</span>
  </MetaButton>
</template>
<script lang="ts" setup>
import { computed } from 'vue';
import MetadataIcon from '@/modules/viewer/components/meta_buttons/MetadataIcon.vue';
import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';
import MetaButton from '@/modules/viewer/components/MetaButton.vue';
import { storeToRefs } from 'pinia';
import { useActiveTabTrigger } from '../../composables/useActiveTab';

const { publicVisitsCount } = storeToRefs(useViewerItemStore());
const { requestTab } = useActiveTabTrigger();

const visitsMessage = computed(() => {
  return publicVisitsCount.value === 1 ? `1 view` : `${publicVisitsCount.value} views`;
});
</script>
